"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_CHUNK_SIZE = exports.DEFAULT_RETENTION_PERIOD_IN_DAYS = exports.MAX_COUNT_OF_ALERTS = exports.MIN_LENGTH = exports.MAX_CONTENT_LENGTH = exports.MAX_TITLE_LENGTH = void 0;
exports.MAX_TITLE_LENGTH = 60;
exports.MAX_CONTENT_LENGTH = 500;
exports.MIN_LENGTH = 1;
exports.MAX_COUNT_OF_ALERTS = 3;
exports.DEFAULT_RETENTION_PERIOD_IN_DAYS = 1825;
exports.DEFAULT_CHUNK_SIZE = 1000;
//# sourceMappingURL=note.consts.js.map